import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/es";

export default {
  locale: "es",
  name: "Condiciones",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "conditionType",
        displayName: "Tipo de condición",
      },
      {
        fieldName: "earlyCharge",
        displayName: "%cobro",
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Cobrar primera noche",
      },
      {
        fieldName: "policies",
        displayName: "Política de Cancelación",
      },
      {
        fieldName: "payments",
        displayName: "Formas de cobro",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Mínimo",
      },
      {
        fieldName: "motorsList",
        displayName: "Motores",
      },
      {
        fieldName: "uso",
        displayName: "Uso",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "conditionType",
        displayName: "Condición tienda",
      },
      {
        fieldName: "isFlightHotelCondition",
        displayName: "Condición Vuelo + Hotel",
      },
      {
        fieldName: "flightHotelPaymentType",
        displayName: "Cobro por adelantado (Maarlab)",
        optionDisplay: {
          FLIGHT_ONLY: { label: "Solo vuelo" },
          ALL_NOW: { label: "Todo ahora" },
          // Temporarily disabled: FLIGHT_NOW_HOTEL_LATER is not offered for now.
          // FLIGHT_NOW_HOTEL_LATER: { label: "Vuelo ahora / hotel después" },
        },
      },
      {
        fieldName: "color",
        displayName: "Color",
      },
      {
        fieldName: "payments",
        displayName: "Formas de cobro",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "earlyCharge",
        displayName: "% cobro anticipado",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Cobro mínimo",
      },
      {
        fieldName: "policies",
        displayName: "Políticas de cancelación",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Cobrar primera noche",
      },
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "htmlCancellation",
        displayName: "Cancelaciones / Pago por adelantado",
      },
      {
        fieldName: "htmlCheckIn",
        displayName: "Hora check-in",
      },
      {
        fieldName: "htmlCheckOut",
        displayName: "Hora check-out",
      },
      {
        fieldName: "htmlChildren",
        displayName: "Niños y camas supletorias",
      },
      {
        fieldName: "htmlPets",
        displayName: "Mascotas",
      },
      {
        fieldName: "htmlGroups",
        displayName: "Grupos",
      },
      {
        fieldName: "htmlExtraInfo",
        displayName: "Más información",
      },
      {
        fieldName: "selectedMotorsSection",
        displayName: "Selección de propiedades",
      },
    ],
  },
};
